import React from 'react';

import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';

import ErrorScreen from 'components/shared/ErrorScreen';
import Loader from 'components/shared/Loader';
import { GUEST_PORTAL_AUTH_FLOW } from 'store/app';
import { guestPortalAuthFlowSelector } from 'store/app/selectors';

import AuthRoutesAccessFlow from '../../../GuestPortalAccess/AuthRoutesAccessFlow';
import ForgotPassword from '../../Auth/ForgotPassword';
import AuthContainerLayout from '../../Auth/Layout';
import ResetPassword from '../../Auth/ResetPassword';
import SignIn from '../../Auth/SignIn';
import Signup from '../../Auth/SignUp';
import Verify from '../../Auth/Verify';
import { useGetPrimaryImageUrl } from '../../functions';
import {
  GP_AUTH_FORGOT_ROUTE,
  GP_AUTH_RESET_ROUTE,
  GP_AUTH_SIGNIN_ROUTE,
  GP_AUTH_SIGNUP_ROUTE,
  GP_AUTH_VERIFY_ROUTE,
} from '../constants';
import { useGPUnViewed } from '../functions';
import { useAuthLoader } from './functions';

// const preloadImage = (src) =>
//   new Promise((r) => {
//     const image = new Image();
//     image.onload = r;
//     image.onerror = r;
//     image.src = src;
//   });

function AuthRoutes() {
  useGPUnViewed();
  const guestPortalAuthFlow = useSelector(guestPortalAuthFlowSelector);

  if (guestPortalAuthFlow === GUEST_PORTAL_AUTH_FLOW.ORIGINAL) {
    return <AuthRoutesOriginalFlow />;
  }

  if (guestPortalAuthFlow === GUEST_PORTAL_AUTH_FLOW.ACCESS) {
    return <AuthRoutesAccessFlow />;
  }

  return null;
}

export default AuthRoutes;

function AuthRoutesOriginalFlow() {
  const { isLoading, error, data } = useAuthLoader();
  const { primaryUrl } = useGetPrimaryImageUrl(data);

  if (error) {
    return <ErrorScreen status="404_guest" />;
  }

  if (isLoading) {
    return <Loader isFillBlock />;
  }

  return (
    <AuthContainerLayout bgImage={primaryUrl}>
      <Switch>
        <Route path={GP_AUTH_SIGNIN_ROUTE}>
          <SignIn />
        </Route>
        <Route path={GP_AUTH_SIGNUP_ROUTE}>
          <Signup />
        </Route>
        <Route path={GP_AUTH_VERIFY_ROUTE}>
          <Verify />
        </Route>
        <Route path={GP_AUTH_FORGOT_ROUTE}>
          <ForgotPassword />
        </Route>
        <Route path={GP_AUTH_RESET_ROUTE}>
          <ResetPassword />
        </Route>

        <Route>
          <ErrorScreen status="404_guest" />
        </Route>
      </Switch>
    </AuthContainerLayout>
  );
}
